import styled from "styled-components";

export const SectionWrapper = styled.section`
  max-width: 480px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #f0f0f0ff;
`;

export const SectionTitle = styled.h2`
  margin-bottom: 15px;
  font-family: "Titillium Web", sans-serif;
  font-weight: 600;
  font-size: 27px;
`;
